type ConfigKey = 'isTermIdWithDownPayment';

class Config {
    private static instance: Config | undefined;
    private config: Record<ConfigKey, boolean>;

    private constructor() {
        this.config = {
            isTermIdWithDownPayment: false
        };
    }
    /**
     * Returns a singleton instance of Config
     * @returns {Config}
     */
    public static getInstance(): Config {
        if (!Config.instance) {
            Config.instance = new Config();
        }
        return Config.instance;
    }
    /**
     * ❌ Used for Testing purposes only!! ❌
     */
    public static reset(): void {
        Config.instance = undefined;
    }

    public setConfig(key: ConfigKey, value: boolean): void {
        this.config[key] = value;
    }

    public getConfig(key: ConfigKey): boolean {
        return this.config[key];
    }
}

export default Config;
